export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40690359a9c2f7e241bfe29d1c92c38ad531f52a79&name=revalidateCommunity!'